// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"your-music-artists_mainHeading_3pwtS"};